import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';
import PropTypes from 'prop-types';
import Row from "../../Row";
import CardHeader from "../../card-header/CardHeader";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import HeaderSearchRefreshFilterOptions from "../../HeaderSearchRefreshFilterOptions";
import Paginator from "../../Paginator";
import CardBody from "../../CardBody";
import * as workerActions from '../../../../worker/actions/workerActions';
import StateManager from "../../../utils/StateManager";
import Tab from "../../Tab";
import WorkersTabTable from "./WorkersTabTable";

class WorkersTab extends React.Component {

  constructor(props){
    super(props);

    this.onRefresh = this.onRefresh.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onPage = this.onPage.bind(this);

    this.state = StateManager.getState(this.props.id);
  }

  componentWillMount(){
    this.props.workerActions.getWorkersStates();
    this.getWorkers();
  }

  componentDidUpdate( prevProps, prevState ){
    if ( prevState.search !== this.state.search
      || prevState.filter !== this.state.filter
      || prevState.page !== this.state.page ){
      this.getWorkers();
    }
    StateManager.saveState(this.props.id, this.state);
  }

  getWorkers(){
    if (!this.props.showDeleted) {
      this.props.workerActions.getWorkers(this.state.page, this.state.search, this.state.filter, this.props.companyId, false, true);
    } else {
      this.props.workerActions.getWorkersDeleted(this.state.page, this.state.search, this.state.filter, this.props.companyId);
    }
  }

  onRefresh(){
    this.getWorkers()
  }

  onSearch(search){
    this.setState({ search: search, page: 1 });
  }

  onPage(page){
    this.setState({ page })
  }

  renderFilterName(){
    const states = _.keyBy(this.props.workersStates, 'id');
    if (states && states[this.state.filter]){
      return states[this.state.filter].name;
    }
    return '';
  }

  renderHeaderOptions(){

    const filterOptions = this.props.workersStates.map((workerState) => {
      return {
        title: workerState.name,
        active: workerState.id === this.state.filter,
        onClick: () => {
          this.setState({ filter: workerState.id, page: 1 });
        },
      }
    });

    return(
      <HeaderSearchRefreshFilterOptions
        onRefresh={this.onRefresh}
        onSearch={this.onSearch}
        searchText={this.state.search}
        filterOptions={filterOptions}
      />
    );
  }

  render() {
    return (
      <Row clearfix={true}>
        <Tab loading={this.props.workersLoading}>
          <CardHeader
            title={this.props.title.toUpperCase()}
            subtitle={this.renderFilterName()}
            rightOptions={this.renderHeaderOptions()}
          />
          <CardBody>
            <WorkersTabTable
              data={this.props.workers}
              error={this.props.workersError}
              selectedIds={this.props.selectedIds}
              actionSelectItem={this.props.actionSelectItem}
              actionSelectAll={this.props.actionSelectAll}
              selectText={this.props.selectText}
              selectAllText={this.props.selectAllText}
              action={this.props.action}
              actionText={this.props.actionText}
              showOutsource={this.props.showOutsource}
            />
            <Paginator
              data={this.props.workersPagination}
              onPage={this.onPage}
            />
          </CardBody>
        </Tab>
      </Row>
  );
  }

}

const mapStateToProps = state => {
  let errorMessage = state.workers.workersError;
  if (!errorMessage && Object.keys(state.workers.workers).length === 0 && !state.workers.workersLoading){
    errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
  }
  const workers = _.map(state.workers.workers);
  return({
    workers: _.sortBy(workers, ['last_name', 'name']),
    workersPagination: state.workers.workersPagination,
    workersLoading: state.workers.workersLoading,
    workersError: errorMessage,
    workersStates: state.workers.workersStates,
  });
}

const mapDispatchToProps = dispatch => ({
  workerActions: bindActionCreators(workerActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkersTab);

WorkersTab.propTypes = {
  id: PropTypes.string.isRequired,
  companyId: PropTypes.string,
  title: PropTypes.string,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  actionSelectAll: PropTypes.func,
  selectText: PropTypes.string,
  selectAllText: PropTypes.string,
  action: PropTypes.any,
  actionText: PropTypes.string,
  showOutsource: PropTypes.bool,
  showDeleted: PropTypes.bool,
};

WorkersTab.defaultProps = {
  companyId: null,
  title: I18nUtils.tr('TR_TRABAJADORES'),
  showOutsource: false,
  showDeleted: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/workers/WorkersTab.js